import * as React from 'react';
import { toast } from 'react-toastify';

import useQueryParams from '../../hooks/useQueryParams';
import { IDashboardTask } from '../../interfaces';
import useTaskReminders from '../../queries/tasks/useTaskReminders';
import { differenceInMilliseconds, formatDate, subMinutes } from '../../utils/date';
import { Link } from '../common';
import alert from '../core/Alert';

export const ReminderBody = ({ task }: { task: IDashboardTask }): React.JSX.Element => {
  const to = task.lead_gid
    ? { pathname: '/guided_selling_experience', search: `?lead_gid=${task.lead_gid}&task_id=${task.id}` }
    : { pathname: `/people/${task.person_gid}`, search: `?task_id=${task.id}` };

  return (
    <>
      <Link to={to} target="_blank" onClick={() => toast.dismiss(task.id)}>
        <div className="fs-mask">{task.customer_name}</div>
      </Link>
      {`${task.description}: is scheduled for ${formatDate(task.due_at, 'hh:mm a')}`}
    </>
  );
};

const TaskReminders = () => {
  const scheduledReminders = React.useRef<number[]>([]);
  const queryParams = useQueryParams();
  const queryParamsRef = React.useRef<URLSearchParams>(undefined);
  queryParamsRef.current = queryParams;

  const { data: tasks } = useTaskReminders();

  React.useEffect(() => {
    const showReminder = (task: IDashboardTask, delay: number): void => {
      if (queryParamsRef.current?.get('task_id') === task.id.toString()) {
        return;
      }

      if (differenceInMilliseconds(task.due_at, new Date()) > 0) {
        const timerId = window.setTimeout(
          () => {
            alert({
              message: <ReminderBody task={task} />,
              title: `You have a scheduled ${task.kind}`,
              options: {
                toastId: task.id
              }
            }).info();
          },
          differenceInMilliseconds(subMinutes(task.due_at, delay), new Date())
        );

        scheduledReminders.current.push(timerId);
      }
    };

    scheduledReminders.current.forEach(timerId => window.clearTimeout(timerId));
    (tasks || []).forEach(task => showReminder(task, 10));
  }, [tasks]);

  return null;
};

export default TaskReminders;
